export default {
  title: 'ماژول ها',

  slugName: {
    users: 'اشخاص',
    products: 'کالا',
    services: 'خدمات',
    sales: 'فروش',
    purchases: 'خرید',
    warehouses: 'انبارداری',
    treasury: 'خزانه داری',
    accountancy: 'حسابداری',
    connector: 'ووکنترلر',
    events: 'پیام ها',
    organizational_tickets: 'تیکت سازمانی',
    support_tickets: 'تیکت پشتیبانی',
    financial_years: 'سال مالی',
    reports: 'گزارشات',
    backups: 'پشتیبانی',
    roles: 'دسترسی',
    settings: 'تنظیمات'
  },

  labels: {
    slug: 'کلید',
    name: 'نام',
    price: 'قیمت ماهیانه',
    salePrice: 'قیمت حراج',
    status: 'وضعیت',
    product: 'محصول',
    description: 'توضیحات',
    delete: 'حذف'
  },

  table: {
    header: {
      row: 'ردیف',
      code: 'کد',
      name: 'نام',
      price: 'قیمت ماهیانه',
      status: 'وضعیت',
    }
  },

  statusTypes: {
    active: 'فعال',
    disable: 'غیرفعال'
  },

  notifications: {
    wrongInputValue: 'اطلاعات وارد شده صحیح نیست',
    requiredModulesNotSelected: 'ماژول های {modules} پیش نیاز این ماژول هستند',
    edit: {
      success: 'ماژول با موفقیت بروزرسانی شد',
      error: 'بروزرسانی ماژول با خطا همراه شد'
    },
    parseError: {
      name: 'نام وارد شده معتبر نیست',
      code: 'کد وارد شده معتبر نیست یا قبلا استفاده شده است',
      price: 'قیمت وارد شده معتبر نیست'
    }
  },

  list: {
    title: 'پلن های فروش'
  },

  trash: {
    title: 'سطل زباله پلن های فروش'
  },

  edit: {
    title: 'ویرایش ماژول',
    dynamicTitle: 'ویرایش ماژول {name}'
  },

  profile: {
    title: 'پروفایل ماژول',
    dynamicTitle: 'پروفایل ماژول {name}',

    importantData: {
      product: 'محصول',
      status: 'وضعیت'
    },

    actions: {
      logs: 'لیست لاگ ها'
    }
  },

  logs: {
    title: 'لاگ های ماژول'
  }
}
